import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import store from '../../store';
import { showModal, MODAL_PIN } from '../../actions/modal';
import {
    updateValuesStorageToContinue,
    modalInactivityPlayOnLIVE,
    handleRedirectModalInactivity,
} from 'src/components/Modal/functions/ModalInactivity/index';
import { AAF_CONTENT_IS_STARTOVER } from 'src/AAFPlayer/constants';
import 'src/components/Modal/styles/ModalInactivity.scss';
import Utils from 'src/utils/Utils';

class ModalInactivity extends Component {
    constructor(props) {
        super(props);
        this.extraClass = 'btn-modal-bookmark';
        this.variant = 'dark';
        this.params = {
            classNameComponent: 'modal-inactivity',
            showLogo: true,
            aafNewStyle: true,
            alwaysEnabled: true,
            buttonsAlign: 'vertical',
            className: 'aaf-modal aaf-modal-error',
            content: Translator.get('continuePlayback_modal_title_label', '¿Sigues ahí?'),
            buttons: [
                {
                    content: Translator.get(
                        'continuePlayback_modal_option_button_continueToSee',
                        'CONTINUAR VIENDO'
                    ),
                    extraClass: `${this.extraClass} modal-inactivity__button-continue`,
                    props: {
                        variant: this.variant,
                        onClick: this.handleOnClickContinue,
                    },
                },
                {
                    content: Translator.get(
                        'continuePlayback_modal_option_button_back',
                        'REGRESAR'
                    ),
                    extraClass: `${this.extraClass} modal-inactivity__button-back`,
                    props: {
                        variant: this.variant,
                        onClick: () => this.handleOnClickReturn('return'),
                    },
                },
            ],
            backRCU: () => this.handleOnClickReturn('return'),
        };
        this.setTimeOutModal = null;
        this.idFocusOnShortcut = null;
    }

    checkTimesInStartOver = () => {
        const { timeEndStartOver } = store.getState().modalInactivity;
        const endContent = `${new Date(timeEndStartOver).toLocaleDateString()} ${new Date(
            timeEndStartOver
        ).toLocaleTimeString()}`;
        const nowDate = `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
        return nowDate < endContent ? true : false;
    };

    addFocusNotification = () => {
        if (!Utils.isNotificationHide()) {
            this.idFocusOnShortcut = setTimeout(() => {
                window.SpatialNavigation.focus('#notification-shortcut-button');
                this.idFocusOnShortcut = null;
            }, 300);
        }
    };

    closeModal = () => {
        store.dispatch(
            showModal({
                modalType: 'HIDE_MODAL',
                modalProps: {},
            })
        );
    };

    handleOnClickReturn = (typeOfRedirect) => {
        handleRedirectModalInactivity(this.props.exit, this.props.history, typeOfRedirect);
        this.props.resetDataModalSleep();
        this.closeModal();
    };

    handleOnClickContinue = () => {
        const { contentStreamType } = store.getState().modalInactivity;
        if (contentStreamType === AAF_CONTENT_IS_STARTOVER) {
            const validated = this.checkTimesInStartOver();
            updateValuesStorageToContinue();
            validated ? this.props.play() : modalInactivityPlayOnLIVE();
            this.addFocusNotification();
            this.closeModal();
        } else {
            updateValuesStorageToContinue();
            this.closeModal();
            this.props.play && this.props.play();
            this.addFocusNotification();
        }
    };

    componentDidMount = () => {
        const { modalActiveTime, fullEPG } = store.getState().modalInactivity;
        this.setTimeOutModal = setTimeout(() => {
            this.handleOnClickReturn('inactivity');
        }, modalActiveTime);
        this.props && typeof this.props.clearLoading === 'function' &&   this.props.clearLoading(); // se ejecuta solo cuando se abre el modal despues de modal PIN
        fullEPG && this.props.toggleEPG(); // solo para live
    };
    componentWillUnmount = () => {
        clearTimeout(this.setTimeOutModal);
    };

    render() {
        return <ModalWrapper {...this.params} />;
    }
}

export default withOnClose(ModalInactivity);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalInactivity.jsx